import { REPORT } from 'common/consts/common';
import { STATIC_TAXONOMY } from 'common/consts/staticTaxonomy';
import LanguageService from 'services/Language.service';

export const getShareUrls = url => {
  const location = encodeURIComponent(url);
  return {
    facebook: `https://facebook.com/sharer/sharer.php?u=${location}`,
    twitter: `https://twitter.com/share?url=${location}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&amp;url=${location}`
  };
};

export const getReportURL = ({ year, period = '' }) => {
  const isYearly = period === STATIC_TAXONOMY.REPORTS.values.YEARLY;
  period = isYearly ? '' : period.replace('q', '');

  const lang = LanguageService.getLang();
  const prefixedURL = LanguageService.isDefault(lang)
    ? REPORT.BASE_URL
    : `${REPORT.BASE_URL}/${lang}`;

  return `${prefixedURL}/${year}/${period}`;
};

export const langPrefixURL = url => {
  const lang = LanguageService.getLang();
  return LanguageService.isDefault(lang) ? url : `/${lang}${url}`;
};

export const assignHttpProtocol = url => {
  const isHttp = /^http/.test(url);

  return isHttp ? url : `https://${url}`;
};



// WEBPACK FOOTER //
// ./src/utils/link-generator-utils.js